export class InvoicingModel {
  preHarvestInvoicing!: number;
  betweenHarvestInvoicing!: number;
  fixedCostInvoicing!: number;
  variableCostInvoicing!: number;
  otherCostEstimatedInvoicing!: number;
  totalInvoicing!: number;
}